<template>
  <section class="contact-section">
    <div class="contact-section-inner">
      <h2 class="contact-title">联系我们</h2>
      <div class="contact-title-line"></div>
      <p class="contact-intro">
        期待与您建立长期合作关系，为您提供专业的企业服务。
      </p>
      <div class="contact-grid">
        <div class="contact-col contact-col--info">
          <h3 class="contact-col-title">公司信息</h3>
          <ul class="contact-info-list">
            <li>
              <span class="contact-icon contact-icon--addr"></span>
              <div class="contact-info-text">
                <span class="contact-info-label">公司地址</span>
                <span class="contact-info-value">江苏省南京市鼓楼区中山北路105-号 中环-锦创数字广场808</span>
              </div>
            </li>
            <li>
              <span class="contact-icon contact-icon--phone"></span>
              <div class="contact-info-text">
                <span class="contact-info-label">联系电话</span>
                <span class="contact-info-value">13913874888</span>
              </div>
            </li>
            <li>
              <span class="contact-icon contact-icon--mail"></span>
              <div class="contact-info-text">
                <span class="contact-info-label">邮箱地址</span>
                <span class="contact-info-value">40079765@qq.com</span>
              </div>
            </li>
            <li>
              <span class="contact-icon contact-icon--time"></span>
              <div class="contact-info-text">
                <span class="contact-info-label">营业时间</span>
                <span class="contact-info-value">周一至周五 9:00-18:00</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="contact-col contact-col--consult">
          <h3 class="contact-col-title">业务咨询</h3>
          <p class="contact-consult-intro">
            如果您对我们的产品或服务有任何疑问，欢迎随时联系我们。我们的专业团队将为您提供详细的产品介绍和咨询服务。
          </p>
          <ul class="contact-consult-list">
            <li>汽车配件采购咨询</li>
            <li>车险产品对比分析</li>
            <li>批量采购优惠</li>
            <li>售后技术支持</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection'
}
</script>

<style scoped>
.contact-section {
  background: #1e293b;
  color: #e2e8f0;
  padding: 64px 16px 72px;
}

.contact-section-inner {
  max-width: 1000px;
  margin: 0 auto;
}

.contact-title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  margin-bottom: 8px;
}

.contact-title-line {
  width: 48px;
  height: 3px;
  background: #ef4444;
  margin: 0 auto 20px;
  border-radius: 2px;
}

.contact-intro {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 40px;
  line-height: 1.6;
}

.contact-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 40px;
  align-items: start;
}

.contact-col-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
}

/* 公司信息 */
.contact-info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}

.contact-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ef4444;
  flex-shrink: 0;
  margin-top: 6px;
}

.contact-info-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-info-label {
  font-size: 14px;
  color: #e2e8f0;
  font-weight: 500;
}

.contact-info-value {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

/* 业务咨询 */
.contact-consult-intro {
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.8;
  margin-bottom: 16px;
}

.contact-consult-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-consult-list li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #cbd5e1;
  line-height: 1.6;
}

.contact-consult-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
}

@media (max-width: 768px) {
  .contact-section {
    padding: 48px 16px 56px;
  }

  .contact-title {
    font-size: 24px;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}
</style>
